import { cn } from '~/utils/cn.ts';

export type ListOfErrors = Array<string | null | undefined> | null | undefined;

export type ErrorClassNames = {
	container?: string;
	li?: string;
	ul?: string;
};

export default function ErrorList({
	classNames,
	id,
	errors,
}: {
	classNames?: ErrorClassNames;
	errors?: ListOfErrors;
	id?: string;
}) {
	if (!id) {
		return null;
	}

	const errorsToRender = errors?.filter(Boolean);
	if (!errorsToRender?.length) {
		return null;
	}

	return (
		<div className={classNames?.container}>
			<ul className={cn('flex flex-col gap-1', classNames?.ul)} id={id}>
				{errorsToRender.map((e) => (
					<li className={cn('text-[10px] text-negative italic', classNames?.li)} key={e}>
						{e}
					</li>
				))}
			</ul>
		</div>
	);
}
